module.exports = "/assets/dw_share.png?EPMUjd8";